





























































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import numeral from 'numeral';

import { STORE_KEY, store } from './_store';

import ShiftAtomJournalForm from './ShiftAtomJournalForm/ShiftAtomJournalForm.vue'
import ShiftBatchIngredientsForm from './ShiftBatchIngredientsForm/ShiftBatchIngredientsForm.vue'
import BatchesManagerForm from './BatchesManagerForm/BatchesManagerForm.vue'
import XLSX from 'xlsx';
import ShiftWashJournalForm from '../ShiftWashJournalForm/ShiftWashJournalForm.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',
      'meta',
      'relatedFactsList', 'ingredients'

      // 'document', 'meta'
    ]),
    ...mapState('ubic', [
      'token'
    ]),
    ...mapGetters(STORE_KEY, [
      'remainsById', 'totals', 'rotateJournal'
    ]),
    ...mapGetters('ubic', [
      'isAdmin'
    ]),
  },
  components: {
    ShiftAtomJournalForm
  }
})
export default class ShiftAtomJournal extends Vue {

  @Prop() documentId!: string;

  opened: any[] = [];
  public dropFiles = [];

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  // items: any[] = [];

  formatNumber(value: any) {
    return numeral(value).format('0,0');
  }

  openDocument(row: any) {
    this.$buefy.modal.open({
      component: ShiftAtomJournalForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  openWashDocument(row: any) {
    this.$buefy.modal.open({
      component: ShiftWashJournalForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }
  openDocumentBatch(row: any, ingredient_id: any) {
    if (!row || !row.shift_atom_batch_id) {
      this.$buefy.modal.open({
        component: BatchesManagerForm,
        props: {
          isNew: true,
          documentPreview: {
          },
          documentId: this.documentId,
          ingredientId: ingredient_id,
          initParams: {
            ingredient_id: row.ingredient_id
          }
        },
        events: {
          'form-close': (result: any) => {
            result = result.result;
            console.log('row', row);
            this.$store.dispatch(`${STORE_KEY}/saveShiftBatch`, {
              journal_ingredient_id: row.id,
              batch_id: result.id
            }).then(() => {
              this.handleParamsChange();
            }).catch((error: any) => {
              console.error('error', error)
            });
          },
        },
        hasModalCard: true,
        fullScreen: true,
        customClass: 'document-form short-form',
        parent: this
      })
    } else {
      this.$buefy.modal.open({
        component: ShiftBatchIngredientsForm,
        props: {
          isNew: !row || !row.shift_atom_batch_id,
          documentPreview: {
            id: row.shift_atom_batch_id,
            journal_ingredient_id: row.journal_ingredient_id
          },
          documentId: this.documentId,
          ingredientId: ingredient_id,
          initParams: {
            journal_ingredient_id: row.id
          }
        },
        events: {
          'form-close': () => {
            this.handleParamsChange();
          },
        },
        hasModalCard: true,
        fullScreen: true,
        customClass: 'document-form short-form',
        parent: this
      })
    }
  }

  tableToExcel() {
    const csvContent: any[] = [];

    csvContent.push(...this.$store.getters[`${STORE_KEY}/exportData`]);
    const ws = XLSX.utils.aoa_to_sheet(csvContent);
    // @ts-ignore
    const range = XLSX.utils.decode_range(ws['!ref']);
    if(!ws["!rows"]) ws["!rows"] = [];
    if(!ws["!cols"]) ws["!cols"] = [];
    const _col_width = {
      '0': 200,
    }
    for(let R = range.s.r; R <= range.e.r; ++R) {

      // @ts-ignore
      if(!ws["!rows"][R]) {
        // @ts-ignore
        ws["!rows"][R] = {hpx: 20}
      }

      for(let C = range.s.c; C <= range.e.c; ++C) {
        // @ts-ignore
        if(!ws["!cols"][C]) {
          // @ts-ignore
          ws["!cols"][C] = {wpx: _col_width[C] ? _col_width[C] : 150}
        }

        const cellref = XLSX.utils.encode_cell({c:C, r:R}); // construct A1 reference for cell
        if(!ws[cellref] || C < 4 || R < 1) continue; // if cell doesn't exist, move on
        const cell = ws[cellref];
        // cell.t = 'n'
        // cell.z = '0.00'
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Отчет");
    XLSX.writeFile(wb, 'export.xlsx')
  }


  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  public exportAsXLSX() {
    this.$store.dispatch(`${STORE_KEY}/exportAsXLSX`, {
      documentId: this.documentId,
    });
  }

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
    });
  }
}

